module.exports = __webpack_public_path__ + "static/0111-c850313e26393c68ab092d9d04b45f8b.svg";